export default class StatisticCreateModalController {
    constructor($scope, $injector, $uibModalInstance, extendedInformation) {
        this.scope = $scope;
        this.injector = $injector;
        this.modalInstance = $uibModalInstance;
        this.extendedInformation = extendedInformation;
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.newCustomColor = {label:'', color: ''};
        this.colors = [];

        this.availableFields = [];
        this.availableSumFields = [];
        this.availablePieFields = [];
        this.availableFilterFields = [{value: 'status', label: 'Status'}];
        this.availableOperators = [{value: '=', label: 'equal'}, {value: '!=', label: 'not equal'}, {
            value: 'in',
            label: 'one of'
        }];
        this.availableValues = [
            {value: 'confirmed', label: this.translateIt('stats.form.filter.values.confirmed')},
            {value: 'listed', label: this.translateIt('stats.form.filter.values.listed')},
            {value: 'requested', label: this.translateIt('stats.form.filter.values.requested')},
            {value: 'cancelled', label: this.translateIt('stats.form.filter.values.cancelled')}
        ];
        this.headline = this._getModalHeadline();
        this._initModel();
        this.convertAvailableFields();
    }

    translateIt(key) {
        return this.translate.instant(key)
    }

    addCustomColor() {
        if(this.newCustomColor.label === '' || this.newCustomColor.color === ''){
            this.alert.error('Error', 'Label and Color are required.')
            return;
        }
        this.model.colors[this.newCustomColor.label] = this.newCustomColor.color;
        this.newCustomColor = {label:'', color:''};
    }

    removeCustomColor(key) {
       delete this.model.colors[key];
    }

    convertAvailableFields() {
        const fields = this.extendedInformation.guestlist.enabled_fields;
        Object.keys(fields).map((fieldKey) => {
            const table = fieldKey === 'contact' ? 'contacts' : 'rsvps';
            Object.keys(fields[fieldKey]).forEach((field) => {
                this.availableFields.push({value: table + '.' + field, label: fields[fieldKey][field].label});

                if (fields[fieldKey][field].type === 'integer') {
                    this.availableSumFields.push({value: table + '.' + field, label: fields[fieldKey][field].label});
                }

                if (fields[fieldKey][field].type !== 'array_of_strings') {
                    this.availablePieFields.push({value: table + '.' + field, label: fields[fieldKey][field].label});
                }
            });
        });

    }

    dismissModal() {
        this.modalInstance.dismiss();
    }

    updateModelField(field, value) {
        this.model[field] = value;
    }

    updateModelFilter(field, value) {
        console.log(field, value.length !== 0)
        if (value.length === 0) {
            this.model.filter = {};
            return;
        }
        this.model.filter[field] = value;
    }

    _initModel() {
        const editData = this.extendedInformation.statistic || {};

        if (!this.isEditForm()) {
            this.model = {
                name: '',
                type: 'pie-chart',
                unanswered: false,
                sum: false,
                sumField: '',
                field: '',
                filter: {},
                colors: {},
            };
            return;
        }

        if (editData.type === 'number') {
            this.model = {
                name: editData.name,
                type: editData.type,
                sum: editData.config.statistic === 'sum' || false,
                sumField: editData.config.statistic === 'sum' ? editData.config.params.field : '',
                unanswered: editData.include_unanswered,
                field: '',
                filter: {},
                colors: {},
            };
            return;
        }
        let baseColors = editData.config.colors || []
        let colors = {}

        this.extendedInformation.data.forEach((result) => colors[result.label] = '');
        baseColors.forEach(({label, color}) => colors[label] = color);
        const filters = editData.config.params.filter || [];
        const statusFilter = filters.find((filter => filter.field === 'status'))
        this.model = {
            name: editData.name || '',
            type: editData.type || 'pie-chart',
            sum: false,
            sumField: '',
            unanswered: editData.include_unanswered,
            field: editData.config.params.groupBy[0],
            filter: statusFilter || {},
            colors: colors
        };

    }

    filterComplete(filter) {
        //
        // if (!filter.field) {
        //     return false
        // }
        //
        // if (!filter.operator) {
        //     return false
        // }

        if (!filter.value) {
            return false
        }

        return true;
    }

    buildStatisticConfig() {
        if (this.model.type !== 'number') {
            return {
                "alias": "statistic",
                "statistic": "customRsvpFieldGroupCount",
                "params": {
                    "groupBy": [
                        this.model.field
                    ],
                    "filter": this.buildFilter()
                },
                colors: this.buildColor(),
            }
        }

        let config = {
            "alias": "statistic",
            "statistic": "count",
            "params": {
                "filter": this.buildFilter()
            },
        }

        if (this.model.sum) {
            config.statistic = 'sum';
            config.params.field = this.model.sumField;
        }

        return config;
    }

    buildFilter() {
        let fixedFilters = []
        if (this.isEditForm()) {
            fixedFilters = this.extendedInformation.statistic.config.params.filter.filter((filter) => filter.field !== 'status');
        }

        if (Object.keys(this.model.filter).length !== 0 && this.filterComplete(this.model.filter)) {
            return [{
                "field": 'status',
                "operator": 'in',
                "value": this.model.filter.value
            }, ...fixedFilters];
        }
        return fixedFilters;
    }

    buildColor() {
        return Object.entries(this.model.colors).map(([label, color]) => ({
            label, color
        }));
    }

    submit() {
        this.submitting = true;

        let payload = {
            "type": this.model.type,
            "name": this.model.name,
            "include_unanswered": this.model.unanswered,
            "config": this.buildStatisticConfig()
        };

        if (this.isEditForm()) {
            this.api
                .put('stats/statistics/' + this.extendedInformation.statistic.id, payload)
                .then(() => {
                    this.submitting = false;
                    this.extendedInformation.refresh();
                    this.modalInstance.close();
                })
                .catch(() => {
                    this.alert.error('Error', 'Error while editing. Please try again.')
                    this.submitting = false;
                });
            return;
        }

        this.api
            .post('stats/guestlists/' + this.extendedInformation.guestlist.id, payload)
            .then(() => {
                this.submitting = false;
                this.extendedInformation.refresh();
                this.modalInstance.close();
            })
            .catch(() => {
                this.alert.error('Error', 'Error while saving. Please try again.')
                this.submitting = false;
            });
    }

    _getModalHeadline() {
        return this.isEditForm() ? this.translateIt('stats.form.edit-headline') : this.translateIt('stats.form.create-headline');
    }

    isEditForm() {
        return this.extendedInformation.statistic !== undefined
    }
}


StatisticCreateModalController.$inject = [
    '$scope',
    '$injector',
    '$uibModalInstance',
    'extendedInformation'
]



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-dashboard/controllers/create-modal.js